import { compose } from 'redux';
import { connect } from 'react-redux';
import localStorage from 'store';
import { connectModal } from 'redux-modal';
import { hide } from 'js/store/actions/modal';
import PremiumModal from 'js/components/organisms/Modals/PremiumModal';
export default compose(connect(function () {
  return {
    user: localStorage.get('userAccount') ? localStorage.get('userAccount').first_name : null
  };
}, function (dispatch) {
  return {
    closeModal: function closeModal() {
      dispatch(hide('PremiumModal'));
    }
  };
}), connectModal({
  name: 'PremiumModal',
  destroyOnHide: false
}))(PremiumModal);